// src/components/SaaS/ComedyMovieDetailPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  fetchUserProfile,
  fetchComedyMovieDetail
} from '../../services/api';

const ComedyMovieDetailPage = () => {
  const { id } = useParams();

  const [userProfile, setUserProfile] = useState(null);
  const [movie, setMovie] = useState(null);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
  );

  useEffect(() => {
    localStorage.setItem(
      'sidebarCollapsed',
      JSON.stringify(sidebarCollapsed)
    );
  }, [sidebarCollapsed]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    const loadUserProfile = async () => {
      try {
        const profile = await fetchUserProfile(token);
        setUserProfile(profile);
      } catch (err) {
        console.error('Error fetching user profile:', err);
      }
    };

    const loadMovie = async () => {
      try {
        const data = await fetchComedyMovieDetail(id);
        setMovie(data);
      } catch (err) {
        console.error('Error fetching comedy movie:', err);
      }
    };

    loadUserProfile();
    loadMovie();
  }, [id]);

  // Convert Google Drive link → embed URL
  const getEmbedUrl = (url) => {
    if (!url) return '';

    const match = url.match(/\/d\/(.*?)\//);

    return match
      ? `https://drive.google.com/file/d/${match[1]}/preview`
      : url;
  };

  if (!movie) {
    return (
      <div className="text-center mt-5">
        Loading...
      </div>
    );
  }

  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="d-flex">

          <Sidebar
            userProfile={userProfile}
            isCollapsed={sidebarCollapsed}
            setIsCollapsed={setSidebarCollapsed}
          />

          <main
            className="flex-grow-1 px-4"
            style={{
              minHeight: '100vh',
              marginLeft: sidebarCollapsed ? '60px' : '220px',
              minWidth: 0
            }}
          >

            {/* HEADER */}
            <div className="text-center mb-4">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                alt="Logo"
                style={{
                  width: '100px',
                  height: '100px'
                }}
              />

              <h1 className="fw-bold d-inline mb-0">
                {movie.title}
              </h1>
            </div>

            {/* MOVIE INFO 
            <div className="d-flex align-items-center gap-4 mb-4">

              {movie.image && (
                <img
                  src={movie.image}
                  alt={movie.title}
                  style={{
                    width: '140px',
                    height: '200px',
                    objectFit: 'cover',
                    borderRadius: '12px'
                  }}
                />
              )}

              <div>
                <h2 className="fw-bold">
                  {movie.title}
                </h2>
              </div>

            </div>
*/}
            {/* VIDEO PLAYER */}
            <div className="mb-4">

              <iframe
                src={getEmbedUrl(movie.description)}
                width="100%"
                height="600"
                allow="autoplay"
                allowFullScreen
                title={movie.title}
                style={{
                  borderRadius: '12px',
                  border: 'none'
                }}
              />

            </div>

          </main>
        </div>
      </div>
    </div>
  );
};

export default ComedyMovieDetailPage;